import "./App.css";
import { Backdrop, Container, createTheme } from "@material-ui/core";
import { convertHex, extractUrlParams } from "./common/utils/Utils";
import * as React from "react";
import GuApp from "./modules/ntn-consumer/ui/gu/GuApp";
import PortalApp from "./modules/ntn-consumer/ui/portail/PortalApp";
export const theme = createTheme({
  palette: {
    primary: {
      main: "#232f66",
    },
    secondary: {
      main: "#ffffff",
    },
    accent1: {
      main: "#484848",
    },
    accent2: {
      main: "#7e7e7e",
    },
    accent3: {
      main: "#f3f3f3",
    },
    error: {
      main: "#F50909FF",
    },
    success: {
      main: "#07851CFF",
    },
  },
});

const buildBackDropLayer = (children) => {
  return (
    <Backdrop
      style={{
        flex: 1,
        zIndex: 200,
        color: "white",
        backgroundColor: convertHex("#232f66", 70),
      }}
      open={true}
    >
      {children}
    </Backdrop>
  );
};

function App(props) {
  const queryParams = extractUrlParams(window.location.href)
  console.log("queryParams" + queryParams["view"]);
  return (
      <>
       { queryParams["view"] == 'gu' && (<GuApp></GuApp>)}
        { queryParams["view"] != 'gu' && (<PortalApp></PortalApp>)}
      </>

  );
}



export default App;
